
import "./UserHome.css"
import User from '../User/User.js'

import LoadingModel from "../3DModels/LoadingModel.js"


export default function UserHome({username}){






    return(
        <div className="UserHome-Wrapper">
            <div className="UserHome_Navigation-Wrapper">
                <div className="Navigation-Wrapper_User-Wrapper">        
                        <User username={username}/>
                 </div>

            <div className="UserHome-Navigation" >
          <button><img  src={require("../Images/friends.png")} alt="noimh"/><p>Friends</p></button>
          <button style={{gap:"0.54vw"}}><img style={{marginLeft:"0.3vw",width:"1.2vw"}} 
          alt="noimg"
           src={require("../Images/MessagesIcon.png")}/><p>Messages</p></button>
          </div>           
            </div>
            <div className="UserHome_Display-Wrapper">
                <h1>User dashboard</h1>
            <LoadingModel id="userHomeLoading" />
            </div>
        </div>
    )
}